import CasinoImageBox from "components/casinoImageBox";
import { useSelector } from "react-redux";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import Appconfig from "../../config/config";
import { useState } from "react";
import Loader from "components/loader";
import CasinoLayout from "components/casinoLayout";
function IndianPoker() {
    const casinoImages = [
        {
            src: '/assets/images/casino/withoutLogin/98789.png',
            title: '7 up & 7 down',
            provider_code: 'AC',
            game_code: '987891',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/56767.png',
            title: 'Live Teenpatti',
            provider_code: 'AC',
            game_code: '567671',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/56768.png',
            title: 'Teenpatti T20',
            provider_code: 'AC',
            game_code: '567681',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/98790.png',
            title: 'Dragon Tiger',
            provider_code: 'AC',
            game_code: '987901',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/56968.png',
            title: 'Hi Low',
            provider_code: 'AC',
            game_code: '569681',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/92037.png',
            title: 'Worli Matka',
            provider_code: 'AC',
            game_code: '920371',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67564.png',
            title: 'Poker',
            provider_code: 'AC',
            game_code: '675642',
            type: 'EV'
        },

        {
            src: '/assets/images/casino/withoutLogin/56967.png',
            title: '32 cards casino',
            provider_code: 'AC',
            game_code: '569672',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/87564.png',
            title: 'Andar Bahar',
            provider_code: 'AC',
            game_code: '875642',
            type: 'EV'
        },

        {
            src: '/assets/images/casino/withoutLogin/98791.png',
            title: 'Amar Akbar Anthony',
            provider_code: 'AC',
            game_code: '987912',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/90100.png',
            title: 'Race 20-20',
            provider_code: 'AC',
            game_code: '901002',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67570.png',
            title: 'Bollywood Casino',
            provider_code: 'AC',
            game_code: '675702',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67565.png',
            title: 'Six player poker',
            provider_code: 'AC',
            game_code: '675652',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/98788.png',
            title: 'Roulette',
            provider_code: 'AC',
            game_code: '987882',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/98566.png',
            title: 'Sic-bo',
            provider_code: 'AC',
            game_code: '985662',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67600.png',
            title: 'Mufflis Teenpatti',
            provider_code: 'AC',
            game_code: '676002',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67610.png',
            title: 'Trio',
            provider_code: 'AC',
            game_code: '676102',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/92038.png',
            title: 'Baccarat',
            provider_code: 'AC',
            game_code: '920382',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67575.png',
            title: 'Casino Meter',
            provider_code: 'DC',
            game_code: '150044',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/67567.png',
            title: 'Poker 20-20',
            provider_code: 'AC',
            game_code: '675671',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67660.png',
            title: '2 Card Teenpatti',
            provider_code: 'AC',
            game_code: '676602',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67620.png',
            title: 'Queen Race',
            provider_code: 'AC',
            game_code: '676202',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67630.png',
            title: 'Teenpatti Test',
            provider_code: 'AC',
            game_code: '676302',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67580.png',
            title: 'Casino War',
            provider_code: 'AC',
            game_code: '675802',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67680.png',
            title: 'The Trap',
            provider_code: 'DC',
            game_code: '150024',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/67640.png',
            title: 'Teenpatti Open',
            provider_code: 'AC',
            game_code: '676401',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67690.png',
            title: '29 Card Baccarat',
            provider_code: 'AC',
            game_code: '676902',
            type: 'EV'
        },
        {
            src: '/assets/images/casino/withoutLogin/67710.png',
            title: 'Race to 17',
            provider_code: 'AC',
            game_code: '677102',
            type: 'EV'
        }
    ]
    const [loading, setLoading] = useState(false);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [iframeUrl, setIframeUrl] = useState('');
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                if (status === "SUCCESS") {
                    setIframeUrl(response.data.launchURL);
                    setLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }

    return (
        <>
            {loading && <Loader />}
            <CasinoLayout casinoImages={casinoImages} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} iframeUrl={iframeUrl} setIframeUrl={setIframeUrl} />
        </>
    );
}

export default IndianPoker;